import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {useAuth} from '../../context/auth';
import {login} from '../../services/auth-service';
import {getIntendedUrl} from '../../utils/auth';
import {ErrorMessage, Field, Form, Formik} from "formik";
import MinimalLayout from "../../layouts/minimal";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {loginRequestSchema} from "../../utils/schemas";
import {useGlobalNotificationMessage} from "../../context/message";
import {AppRoutes} from "../../utils/constants";

export default function Login () {
  const auth = useAuth();
  const navigate = useNavigate();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();

  const handleSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    login({
      login: values.login,
      password: values.password
    }).then((responseData) => {
      auth.setToken(responseData.token);
      auth.doAppUserLogin(responseData.user);
      getIntendedUrl() ? navigate(getIntendedUrl()) : navigate(AppRoutes.home.path);
    }).catch(error => {
      if( error.response ){
        HelperService.handleApiErrors(error, addErrorMessage, "Prihlásenie nebolo úspešné. Prosím skontrolujte si zadané údaje. V prípade, že ste zabudli heslo, môžete si ho obnoviť.");
      }
      HelperService.handleFormErrors(error, setErrors);
    }).finally(()=>{setSubmitting(false);});
  };

  return (
    <>
      <Section animation={HelperService.getRandomAnimation()}>
        <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xxl-4 col-lg-5">
                <div className="card">

                  <div className="card-header pt-4 pb-4 text-center bg-primary bg-pattern">
                    <Link to={AppRoutes.landing.path}>
                      <span><img src="/images/logo.png" alt="" height="50" /></span>
                    </Link>
                  </div>

                  <div className="card-body p-4">

                    <div className="text-center w-75 m-auto">
                      <h4 className="text-dark-50 text-center pb-0 fw-bold">Prihlásenie</h4>
                      <p className="text-muted mb-4">Zadajte svoje prihlasovacie meno a heslo pre prístup ku aplikácii</p>
                    </div>

                    <Formik
                      initialValues={loginRequestSchema.cast()}
                      validationSchema={loginRequestSchema}
                      onSubmit={handleSubmit}
                     >
                      {({ isSubmitting, errors, touched }) => (
                        <Form>
                          <div className="mb-3">
                            <label htmlFor="login" className="form-label">Login</label>
                            <Field type="text" required
                                   name="login"
                                   placeholder="Váš prihlasovací údaj alebo email"
                                   className={`form-control ${errors.login && touched.login ? "is-invalid":""}`} />
                            <ErrorMessage name="login" component="div" className="invalid-feedback" />
                          </div>
                          <div className="mb-3">
                            <label htmlFor="password" className="form-label">Heslo</label>
                            <Field type="password" required
                                   name="password"
                                   placeholder="Vaše heslo"
                                   className={`form-control ${errors.password && touched.password ? "is-invalid":""}`} />
                            <ErrorMessage name="password" component="div" className="invalid-feedback" />
                          </div>

                          <div className={"text-center"}>
                            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>Prihlásiť</button>
                          </div>
                        </Form>
                      )}
                    </Formik>

                    <hr className={"mt-4 d-block"} />

                    <p className="mb-4 text-center">
                      <Link to={AppRoutes.passwordRecovery.path} className={"link-secondary"}>Obnova hesla</Link>
                    </p>

                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}

Login.getLayout = function getLayout(page) {
  return (
    <MinimalLayout>
      {page}
    </MinimalLayout>
  )
}

Login.getSEO = function getSEO() {
  return {
    title: "Prihlásenie",
  }
}
